export const categories = ['unread', 'archive'] as const;
